import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { InstallationFeaturesStore } from '@store';
import {
  ActivateDeactivateCommands,
  Feature,
  FeatureCommands,
  FeatureNames,
  FeaturePropertyKey,
  RoomsStatusProperties,
  SrcCondensateAvoidanceCommands,
  SrcPumpControlStatusProperties,
} from '@vi-iot/client/index';

@Component({
  selector: 'app-e3-src-settings-intelligent-heat-control',
  templateUrl: './e3-src-settings-intelligent-heat-control.component.html',
  styleUrls: ['./e3-src-settings-intelligent-heat-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class E3SrcSettingsIntelligentHeatControlComponent {
  @Input({ required: true }) status: Feature<RoomsStatusProperties, ActivateDeactivateCommands>;
  @Input({ required: true })
  set ftdcFeatures(
    value: Feature<SrcPumpControlStatusProperties, SrcCondensateAvoidanceCommands>[]
  ) {
    this.channelEntries = value.map((feature) => {
      const channelId = this.extractChannelId(feature.feature);

      return {
        feature,
        channelId,
        channelNumber: `${parseInt(channelId, 10) + 1}`,
      };
    });
  }

  channelEntries: {
    feature: Feature<SrcPumpControlStatusProperties, SrcCondensateAvoidanceCommands>;
    channelNumber: string;
    channelId: string;
  }[] = [];

  readonly featurePropertyKey = FeaturePropertyKey;
  readonly featureCommands = FeatureCommands;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  onToggleChange(
    toggle: MatSlideToggle,
    feature: Feature<SrcPumpControlStatusProperties, SrcCondensateAvoidanceCommands>
  ): void {
    const { gatewayId, deviceId } = feature;
    const channelId = this.extractChannelId(feature.feature);

    this.installationFeaturesStore.updateFeature(
      FeatureNames.srcChannelFTDC(channelId),
      toggle.checked,
      FeaturePropertyKey.active,
      null,
      FeatureCommands.setActive,
      gatewayId,
      deviceId
    );
  }

  private extractChannelId(featureName: string): string {
    const match = featureName.match(/supplyChannel(\d+)FTDC/);

    return match ? match[1] : '0';
  }
}
